import { APP_LOCALES, APP_STORE, APP_THEME } from '@/constants/app.constant'
import type { AppLocale } from '@/types'
import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useAppStore = defineStore(
  APP_STORE.APP,
  () => {
    const locale = ref<AppLocale>(APP_LOCALES.VI)
    const isDark = ref<boolean>(false)

    const setLocale = (lang: AppLocale) => {
      locale.value = lang
    }

    const toggleTheme = () => {
      isDark.value = !isDark.value
    }

    watch(isDark, (dark) => {
      if (dark) {
        document.documentElement.classList.add(APP_THEME.DARK)
      } else {
        document.documentElement.classList.remove(APP_THEME.DARK)
      }
    }, { immediate: true })

    return { locale, isDark, setLocale, toggleTheme }
  },
  { persist: true }
)
